import React from 'react';
import { AppBar, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useStyles } from './styles';
import AddIcon from '@material-ui/icons/AddCircle';

interface Props {
  forwardEnabled: boolean;
  backwardLink: string;
  setShowModal: (value: boolean) => void;
}

export const FinalPageFooter = (props: Props) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <AppBar className={classes.appBar} color="inherit" position="fixed">
      <div style={{ display: 'inline-block' }}>
        <Button
          className={classes.backButton}
          size={window.screen.width < 700 ? 'small' : 'large'}
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon style={{ color: 'white', marginRight: 5 }} />
          Back
        </Button>
        <Button
          variant="contained"
          className={props.forwardEnabled ? classes.nextButton : classes.disabledButton}
          disabled={!props.forwardEnabled}
          size={window.screen.width < 700 ? 'small' : 'large'}
          onClick={() => props.setShowModal(true)}
        >
          <AddIcon style={{ color: 'white', marginRight: 10 }} />
          Save To My Spotify!
        </Button>
      </div>
    </AppBar>
  );
};
